// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1x5jd","card":"Cards_card__uqCiZ","infected":"Cards_infected__35Bih","recovered":"Cards_recovered__18Yg5","deaths":"Cards_deaths__2jiVu"};